/* Defender 2026 product page sections (d26-pdp-*): feature map, drag-line compares, photo stack, video loops, gallery notes,
   sock buying options.
   Ported from the Ninja Hoodie prototype BH signed off on 2026-11-02. Each section can appear more than once; every
   init works inside its own root and marks it done, so the theme editor's section reloads re-run cleanly. */
(function () {
  if (window.D26PDP) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = window.matchMedia('(min-width: 900px)');
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  /* Drag-line compare: drag anywhere (or arrow keys on the hidden range) to move the line. Touch only takes over once the
     finger moves sideways, so the page still scrolls; a tap jumps the line there. */
  function dragLine(el) {
    var range = $('input', el), hd = null;
    function set(v) { v = Math.max(0, Math.min(100, v)); if (range) range.value = v; el.style.setProperty('--p', v + '%'); }
    function at(e) { var r = el.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); }
    el.addEventListener('pointerdown', function (e) {
      hd = { x: e.clientX, moved: e.pointerType === 'mouse' };
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      if (hd.moved) { e.preventDefault(); at(e); }
    });
    el.addEventListener('pointermove', function (e) { if (!hd) return; if (!hd.moved && Math.abs(e.clientX - hd.x) > 6) hd.moved = true; if (hd.moved) at(e); });
    el.addEventListener('pointerup', function (e) { if (hd && !hd.moved) at(e); hd = null; });
    el.addEventListener('pointercancel', function () { hd = null; });
    if (range) range.addEventListener('input', function () { set(+range.value); });
    return set;
  }

  /* Looping videos: play while on screen, optional pause button, still frame with reduced motion */
  var ICON_PAUSE = '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><rect x="2" y="1.5" width="3" height="9"/><rect x="7" y="1.5" width="3" height="9"/></svg>';
  var ICON_PLAY = '<svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M3 1.5v9l7.5-4.5z"/></svg>';
  function initLoop(v) {
    if (!once(v, 'd26pdpLoop')) return;
    var btn = v.parentNode.querySelector('.d26pdp-play'), userPaused = reduce;
    function setBtn() { if (!btn) return; var on = !v.paused; btn.innerHTML = on ? ICON_PAUSE : ICON_PLAY; btn.setAttribute('aria-label', on ? 'Pause the video' : 'Play the video'); }
    v.addEventListener('play', setBtn); v.addEventListener('pause', setBtn); setBtn();
    if (btn) btn.addEventListener('click', function () { if (v.paused) { userPaused = false; v.play().catch(function () {}); } else { userPaused = true; v.pause(); } });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !userPaused) v.play().catch(function () {}); else if (!e.isIntersecting) v.pause(); }); }, { threshold: .25 }).observe(v);
    }
    /* the Polartec render sits on a bone panel: match the panel to the video's own first pixels so there is no seam */
    if (v.hasAttribute('data-d26pdp-match')) {
      var match = function () {
        try {
          var c = document.createElement('canvas'); c.width = 1; c.height = 1;
          var x = c.getContext('2d'); x.drawImage(v, 0, 0, 12, 12, 0, 0, 1, 1);
          var d = x.getImageData(0, 0, 1, 1).data;
          v.parentNode.style.background = 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
        } catch (e) {}
      };
      v.addEventListener('loadeddata', match); if (v.readyState >= 2) match();
    }
  }

  /* The cloth we use (Flannel): the weave-in render plays once each time the panel comes into view, then crossfades into the
     floating loop (the clip's last frame is the loop's first frame). Reduced motion: the finished swatch, still. */
  function initWeave(box) {
    if (!once(box, 'd26pdpWeave')) return;
    var vin = box.querySelector('.d26pdp-cl-in'), vloop = box.querySelector('.d26pdp-cl-loop');
    if (!vin || !vloop) return;
    function showLoop() { box.classList.add('is-looping'); vloop.currentTime = 0; vloop.play().catch(function () {}); }
    function weave() { box.classList.remove('is-looping'); vloop.pause(); vloop.preload = 'auto'; vin.currentTime = 0; vin.play().catch(showLoop); }
    vin.addEventListener('ended', showLoop);
    if (reduce || !('IntersectionObserver' in window)) { box.classList.add('is-looping'); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) weave(); else { vin.pause(); vloop.pause(); } });
    }, { threshold: .35 }).observe(box);
  }

  /* Feature map: numbered dots on the studio shot, cards that swipe (phone) or list (desktop), a story-style tour.
     Each feature shows as a drag-line compare (signature), a zoom into the photo (fabric) or its own close-up. */
  function initFeatureMap(root) {
    if (!once(root, 'd26pdpFmap')) return;
    var stage = $('.d26pdp-fm-stage', root), zoom = $('.d26pdp-fm-zoom', stage), deck = $('.d26pdp-fm-deck', root);
    var bar = $('.d26pdp-fm-bar', stage), resetBtn = $('.d26pdp-fm-reset', stage), tourBtn = $('.d26pdp-tour', root);
    var hood = $('.d26pdp-fm-hood', stage), hoodR = hood ? $('input', hood) : null, setLine = hood ? dragLine(hood) : null;
    var cards = $$('.d26pdp-fm-card:not(.is-intro)', deck), hss = $$('.d26pdp-hs', stage), shots = $$('.d26pdp-fm-shot', stage);
    var F = cards.map(function (c) { var d = c.dataset; return { mode: d.mode, x: +d.x, y: +d.y, zx: +(d.zx || d.x), zy: +(d.zy || d.y), z: +(d.z || 2.35) }; });
    var active = -1, touring = false, tourT, deckTimer, DUR = 4200;
    /* Phone: size the photo from what's actually left on screen, so heading, photo and card fit any phone (the CSS
       100svh rule is only the first guess; card text wraps taller on narrow screens) */
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100svh;visibility:hidden;pointer-events:none';
    document.body.appendChild(probe);
    function fit() {
      if (desk.matches) { stage.style.height = ''; return; }
      var head = $('.d26pdp-fm-head', root), body = $('.d26pdp-fm-body', root), wrap = $('.d26pdp-wrap', root);
      var cs = getComputedStyle(root), ws = getComputedStyle(wrap);
      var used = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + head.offsetHeight + parseFloat(getComputedStyle(head).marginBottom) + parseFloat(getComputedStyle(body).rowGap || 0) + deck.offsetHeight + 4;
      var maxW = wrap.clientWidth - parseFloat(ws.paddingLeft) - parseFloat(ws.paddingRight);
      stage.style.height = Math.round(Math.max(250, Math.min((probe.offsetHeight || window.innerHeight) - used, maxW * 1.25))) + 'px';
    }
    fit();
    var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fit, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    function scrollDeckTo(i) {
      if (desk.matches) return;
      var target = i < 0 ? deck.children[0] : cards[i];
      deck.scrollTo({ left: target.offsetLeft - deck.offsetLeft - parseFloat(getComputedStyle(deck).scrollPaddingLeft || 0), behavior: reduce ? 'auto' : 'smooth' });
    }
    function activate(i, moveDeck) {
      if (i === active) return;
      active = i;
      var on = i >= 0, f = on ? F[i] : null;
      stage.classList.toggle('is-zoomed', on);
      resetBtn.hidden = !on;
      hss.forEach(function (h, k) { h.classList.toggle('is-on', k === i); });
      cards.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      if (on) { zoom.style.setProperty('--ox', f.zx + '%'); zoom.style.setProperty('--oy', f.zy + '%'); stage.style.setProperty('--z', f.z); }
      var hoodMode = on && f.mode === 'compare' && !!hood;
      stage.classList.toggle('is-hoodmode', hoodMode);
      if (hoodR) hoodR.tabIndex = hoodMode ? 0 : -1;
      if (hoodMode) setLine(50);
      stage.classList.toggle('is-zoommode', on && (hoodMode || f.mode === 'zoom'));
      stage.classList.toggle('is-shotmode', on && f.mode === 'closeup');
      shots.forEach(function (s) { s.classList.toggle('is-on', on && +s.dataset.i === i); });
      if (moveDeck) scrollDeckTo(i);
    }
    hss.forEach(function (h, i) { h.addEventListener('click', function () { stopTour(); activate(i, true); }); });
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { stopTour(); activate(i, true); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stopTour(); activate(i, true); } });
    });
    resetBtn.addEventListener('click', function () { stopTour(); activate(-1, true); });
    deck.addEventListener('scroll', function () {
      if (desk.matches || touring) return;
      clearTimeout(deckTimer);
      deckTimer = setTimeout(function () {
        var x = deck.scrollLeft, best = -1, bestD = Infinity, pad = parseFloat(getComputedStyle(deck).scrollPaddingLeft || 0);
        $$('.d26pdp-fm-card', deck).forEach(function (c, k) { var d = Math.abs(c.offsetLeft - deck.offsetLeft - pad - x); if (d < bestD) { bestD = d; best = k; } });
        activate(best - 1, false);
      }, 90);
    }, { passive: true });
    function segs() { return $$('span', bar); }
    function stopTour() {
      if (!touring) return;
      touring = false; clearTimeout(tourT); bar.hidden = true;
      tourBtn.setAttribute('aria-pressed', 'false'); $('span', tourBtn).textContent = tourBtn.dataset.start;
    }
    function tourStep(i) {
      if (!touring) return;
      if (i >= F.length) { stopTour(); activate(-1, true); return; }
      segs().forEach(function (s, k) { s.className = k < i ? 'is-done' : (k === i ? 'is-run' : ''); });
      var d = F[i].mode === 'compare' ? DUR + 1200 : DUR; bar.style.setProperty('--dur', d + 'ms');
      activate(i, true);
      tourT = setTimeout(function () { tourStep(i + 1); }, d);
    }
    if (tourBtn) tourBtn.addEventListener('click', function () {
      if (touring) { stopTour(); return; }
      touring = true; bar.hidden = false; tourBtn.setAttribute('aria-pressed', 'true'); $('span', tourBtn).textContent = tourBtn.dataset.stop;
      activate(-1, false);
      (desk.matches ? stage : root).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: desk.matches ? 'center' : 'start' });
      setTimeout(function () { tourStep(0); }, reduce ? 0 : 450);
    });
    stage.addEventListener('pointerdown', function (e) { if (!e.target.closest('.d26pdp-hs')) stopTour(); });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input, .d26pdp-fm-deck')) return;
      if (e.key === 'ArrowRight') { stopTour(); activate(Math.min(F.length - 1, active + 1), true); }
      if (e.key === 'ArrowLeft') { stopTour(); activate(Math.max(-1, active - 1), true); }
    });
  }

  /* Photo stack: a pile of prints. Flick left or right (both move forward), tap, arrows or keys; it loops. */
  function initStack(root) {
    if (!once(root, 'd26pdpStack')) return;
    var pile = $('.d26pdp-pile', root), prints = $$('.d26pdp-print', pile), count = $('.d26pdp-stack-count', root);
    var prev = $('[data-d26pdp-prev]', root), next = $('[data-d26pdp-next]', root);
    var ANG = [-4, 5, -6, 4.5, -5, 6, -3, 4];
    var order = prints.map(function (_, k) { return k; }), busy = false, pd = null;
    function lay(skip) {
      order.forEach(function (k, d) {
        if (k === skip) return;
        var c = prints[k], a = ANG[k % ANG.length];
        c.style.zIndex = 20 - d; c.style.opacity = d > 3 ? 0 : 1;
        c.style.transform = d === 0 ? 'rotate(' + (a * .25) + 'deg)' : 'translate(' + (a > 0 ? 1 : -1) * d * 6 + 'px, ' + (d * 4) + 'px) rotate(' + a + 'deg) scale(' + (1 - d * .03) + ')';
        c.classList.toggle('is-top', d === 0); c.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
      });
      if (count) count.textContent = (order[0] + 1) + ' / ' + prints.length;
    }
    function fwd(dir) {
      if (busy || prints.length < 2) return; busy = true;
      var k = order.shift(); order.push(k); var c = prints[k];
      lay(k);
      c.style.zIndex = 30; c.style.opacity = 0; c.style.transform = 'translateX(' + (dir * 125) + '%) rotate(' + (dir * 18) + 'deg)';
      setTimeout(function () { c.style.transition = 'none'; lay(); void c.offsetWidth; c.style.transition = ''; busy = false; }, reduce ? 0 : 380);
    }
    function back() {
      if (busy || prints.length < 2) return; busy = true;
      var k = order.pop(); order.unshift(k); var c = prints[k];
      c.style.transition = 'none'; c.style.zIndex = 30; c.style.opacity = 0; c.style.transform = 'translateX(-125%) rotate(-18deg)';
      void c.offsetWidth; c.style.transition = '';
      lay(); setTimeout(function () { busy = false; }, reduce ? 0 : 380);
    }
    pile.addEventListener('pointerdown', function (e) {
      var c = e.target.closest('.d26pdp-print'); if (!c || !c.classList.contains('is-top') || busy) return;
      pd = { c: c, x: e.clientX, y: e.clientY, dx: 0, on: false, t: Date.now() };
      try { c.setPointerCapture(e.pointerId); } catch (err) {}
    });
    pile.addEventListener('pointermove', function (e) {
      if (!pd) return;
      var dx = e.clientX - pd.x, dy = e.clientY - pd.y;
      if (!pd.on) { if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) { pd.on = true; pd.c.classList.add('is-dragging'); } else return; }
      pd.dx = dx; pd.c.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx * .06) + 'deg)';
    });
    function end(cancel) {
      if (!pd) return; var d = pd; pd = null; d.c.classList.remove('is-dragging');
      if (!d.on) { if (!cancel) fwd(-1); return; }
      var fast = Math.abs(d.dx) > 30 && Math.abs(d.dx) / Math.max(1, Date.now() - d.t) > .35;
      if (!cancel && (Math.abs(d.dx) > 55 || fast)) fwd(d.dx > 0 ? 1 : -1); else lay();
    }
    pile.addEventListener('pointerup', function () { end(false); });
    pile.addEventListener('pointercancel', function () { end(true); });
    pile.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); fwd(-1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); back(); }
    });
    if (next) next.addEventListener('click', function () { fwd(-1); });
    if (prev) prev.addEventListener('click', back);
    lay();
  }

  /* Product details tabs: Overview / Specs & features. Click, or arrow keys once a tab has focus. */
  function initTabs(root) {
    if (!once(root, 'd26pdpTabs')) return;
    var tabs = $$('[role="tab"]', root);
    function pick(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t, p = document.getElementById(x.getAttribute('aria-controls'));
        x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); pick(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
  }

  /* Specs & features: the metafield's rich text, laid out as in the prototype. A bold line starts a block (first line =
     heading, the rest = the material line under it); "KEY: value" lists become a care grid; a Label list joins on one
     line. The first block (Features) takes the left column, the rest the right. Anything else is left as written. */
  function initSpec(el) {
    if (!once(el, 'd26pdpSpec')) return;
    var src = el.querySelector('.metafield-rich_text_field') || el, made = null, blocks = [], cur = null;
    function lines(node) {
      var c = node.cloneNode(true);
      $$('br', c).forEach(function (br) { br.parentNode.replaceChild(document.createTextNode('\n'), br); });
      return c.textContent.split(/\n+/).map(function (s) { return s.trim(); }).filter(Boolean);
    }
    Array.prototype.slice.call(src.children).forEach(function (k) {
      var b = k.tagName === 'P' && k.querySelector('strong, b');
      if (b && b.textContent.trim() === k.textContent.trim()) {
        var ls = lines(k);
        cur = { h: ls[0].replace(/:\s*$/, ''), sub: ls.slice(1).join(' '), body: [] }; blocks.push(cur);
      } else if (!cur && k.tagName === 'P') { made = k.textContent.trim(); }
      else if (cur) cur.body.push(k);
    });
    if (!blocks.length) return;
    function txt(tag, cls, t) { var n = document.createElement(tag); if (cls) n.className = cls; n.textContent = t; return n; }
    var grid = document.createElement('div'), left = document.createElement('div'), right = document.createElement('div');
    grid.className = 'd26pdp-spec-grid'; grid.appendChild(left); grid.appendChild(right);
    blocks.forEach(function (bl, i) {
      var box = document.createElement('div'); box.className = 'd26pdp-spec-block';
      box.appendChild(txt('h3', '', bl.h));
      if (bl.sub) box.appendChild(txt('p', 'd26pdp-spec-sub', bl.sub));
      bl.body.forEach(function (n) {
        var items = /^(UL|OL)$/.test(n.tagName) ? $$('li', n).map(function (li) { return li.textContent.trim(); }) : null;
        var kv = items && items.length && items.every(function (s) { return /^[A-Z][A-Z ]+:\s*\S/.test(s); });
        if (kv) {
          var dl = document.createElement('dl'); dl.className = 'd26pdp-spec-care';
          items.forEach(function (s) {
            var m = s.match(/^([A-Z][A-Z ]+):\s*(.+)$/), row = document.createElement('div');
            row.appendChild(txt('dt', '', m[1].toLowerCase())); row.appendChild(txt('dd', '', m[2])); dl.appendChild(row);
          });
          box.appendChild(dl);
        } else if (items && /label|composition/i.test(bl.h)) box.appendChild(txt('p', 'd26pdp-spec-line', items.join(' · ')));
        else box.appendChild(n);
      });
      (i === 0 ? left : right).appendChild(box);
    });
    el.innerHTML = '';
    if (made) el.appendChild(txt('p', 'd26pdp-spec-made', made));
    el.appendChild(grid);
  }

  /* Gallery notes: feature captions and model size tags laid over the theme's own gallery, matched on each photo's alt
     text (case-insensitive). Re-applied whenever the gallery re-renders, e.g. after a colour change.
     A match ending in "$" must end the alt text, for alts that are the start of another photo's alt; one that also starts
     with "^" must be the whole alt text (e.g. "^Midnight Black$"). */
  function initGalleryNotes(script) {
    if (!once(script, 'd26pdpNotes')) return;
    var cfg; try { cfg = JSON.parse(script.textContent); } catch (e) { return; }
    var scope = script.closest('.js-main-product') || script.closest('section') || document;
    function has(a, m) {
      m = m.toLowerCase();
      if (m.slice(-1) !== '$') return a.indexOf(m) > -1;
      m = m.slice(0, -1);
      if (m.charAt(0) === '^') return a.trim() === m.slice(1);
      return a.slice(-m.length) === m;
    }
    function noteFor(alt) {
      var a = alt.toLowerCase(), out = [];
      (cfg.tags || []).forEach(function (r) {
        if (!r.match.some(function (m) { return has(a, m); })) return;
        var t = r.text;
        if (r.sizes) { Object.keys(r.sizes).forEach(function (c) { if (a.indexOf(c.toLowerCase()) > -1) t = t.replace('{size}', r.sizes[c]); }); }
        if (t.indexOf('{size}') === -1) out.push({ k: 'tag', t: t, full: !!r.full });
      });
      (cfg.captions || []).forEach(function (r) { if (r.match.some(function (m) { return has(a, m); })) out.push({ k: 'cap', t: r.text }); });
      return out;
    }
    function hides(alt) { var a = alt.toLowerCase(); return (cfg.hide || []).some(function (m) { return has(a, m); }); }
    function apply() {
      /* Shots the page's gallery leaves out stay on the product, just out of this gallery (slides, thumbnails and zoom). */
      if (cfg.hide) $$('.js-product-slideshow-item, .js-product-slideshow-thumb, .js-gallery-thumb, .js-gallery-slide').forEach(function (el) {
        var im = el.querySelector('img'); if (im && im.alt && hides(im.alt)) el.classList.add('d26pdp-ghide');
      });
      /* A yellow dot on the thumbnail marks a captioned feature photo. */
      $$('.js-product-slideshow-thumb', scope).forEach(function (th) {
        var b = th.querySelector('button'), im = th.querySelector('img');
        if (!b || !im || !im.alt || b.querySelector('.d26pdp-gdot')) return;
        if (noteFor(im.alt).some(function (n) { return n.k === 'cap'; })) b.insertAdjacentHTML('beforeend', '<span class="d26pdp-gdot" aria-hidden="true"></span>');
      });
      $$('.js-product-slideshow-item', scope).forEach(function (item) {
        if (item.querySelector('.d26pdp-gnote')) return;
        var im = item.querySelector('img'); if (!im || !im.alt) return;
        var seen = {};
        noteFor(im.alt).forEach(function (n) {
          if (seen[n.k]) return; seen[n.k] = 1;
          if (n.full) item.classList.add('d26pdp-gfull');   // full-length fit shots show the whole figure, head to shoes
          var el = document.createElement('span'); el.className = 'd26pdp-gnote ' + (n.k === 'tag' ? 'd26pdp-gtag' : 'd26pdp-gcap');
          if (n.k === 'tag') el.textContent = n.t; else { el.innerHTML = '<span><i></i></span>'; el.firstChild.appendChild(document.createTextNode(n.t)); }
          item.appendChild(el);
        });
      });
    }
    apply();
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 60); }).observe(scope, { childList: true, subtree: true });
  }

  /* Key feature switch (Quarter-Zip: Moving / Stopped). Two aligned looping renders cross-fade, and each state opens on
     its first frame. The watch readout follows the state: the heart trace races in the first state and eases to a resting
     beat in the second, and its labels swap. It switches on its own while on screen until the shopper taps it, then stays
     where they put it. Videos and the trace only run on screen; reduced motion keeps everything still. */
  function initSwitch(root) {
    if (!once(root, 'd26pdpSw')) return;
    var btns = $$('.d26pdp-sw-seg button', root), vids = $$('video', root), cap = $('.d26pdp-sw-cap', root);
    var auto = !reduce, seen = false, timer, DUR = 4500;
    root.style.setProperty('--d26sw-dur', DUR + 'ms');
    var cv = $('.d26pdp-sw-ecg', root), cx = cv && cv.getContext('2d'), heart = $('.d26pdp-sw-heart', root);
    var EW = cv ? cv.width : 0, EH = cv ? cv.height : 0, MID = EH * .62, line = [], since = 0, bi = -1, gap = .42, gapTo = .42, running = false, last = 0;
    var BEAT = [0, -.06, -.1, -.06, 0, 0, .1, -.95, .4, 0, 0, 0, -.1, -.17, -.2, -.17, -.1, 0];   // small P wave, sharp spike, T wave
    for (var k = 0; k < EW; k++) line.push(MID);
    function step(dt) {
      gap += (gapTo - gap) * Math.min(1, dt * 1.6);          // the beat rate eases between states
      for (var n = Math.round(dt * 70); n > 0; n--) {         // the trace scrolls 70 canvas px a second
        since += 1 / 70;
        var y = MID + (Math.random() - .5) * 1.2;
        if (bi < 0 && since >= gap) {
          bi = 0; since = 0;
          if (running && heart) { heart.classList.add('is-beat'); setTimeout(function () { heart.classList.remove('is-beat'); }, 140); }
        }
        if (bi >= 0) { y = MID + BEAT[bi] * EH * .5; bi = bi + 1 < BEAT.length ? bi + 1 : -1; }
        line.push(y); line.shift();
      }
    }
    function draw() {
      if (!cx) return;
      cx.clearRect(0, 0, EW, EH);
      var g = cx.createLinearGradient(0, 0, EW, 0); g.addColorStop(0, 'rgba(255,209,28,0)'); g.addColorStop(.35, 'rgba(255,209,28,.85)'); g.addColorStop(1, '#FFD11C');
      cx.strokeStyle = g; cx.lineWidth = 2.6; cx.lineJoin = 'round'; cx.beginPath();
      line.forEach(function (y, x) { if (x) cx.lineTo(x, y); else cx.moveTo(x, y); });
      cx.stroke();
      cx.fillStyle = '#FFD11C'; cx.beginPath(); cx.arc(EW - 3, line[EW - 1], 3.2, 0, 7); cx.fill();
    }
    function frame(t) { if (!running) return; var dt = last ? Math.min(.05, (t - last) / 1000) : 0; last = t; step(dt); draw(); requestAnimationFrame(frame); }
    function setState(s) {
      if (root.dataset.state === s) return;
      root.dataset.state = s;
      btns.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.s === s ? 'true' : 'false'); });
      $$('.d26pdp-sw-layer', root).forEach(function (l) { l.classList.toggle('is-on', l.dataset.s === s); });
      var v = $('.d26pdp-sw-layer[data-s="' + s + '"] video', root); if (v) { try { v.currentTime = 0; } catch (e) {} }
      if (cap) cap.classList.add('is-swap');
      setTimeout(function () { $$('[data-a]', root).forEach(function (el) { el.textContent = el.dataset[s]; }); if (cap) cap.classList.remove('is-swap'); }, reduce ? 0 : 220);
      gapTo = s === 'a' ? .42 : 1.1;
    }
    function cycle() {
      clearTimeout(timer); root.classList.remove('is-auto');
      if (!auto || !seen) return;
      void root.offsetWidth; root.classList.add('is-auto');   // restarts the progress line under the active button
      timer = setTimeout(function () { setState(root.dataset.state === 'a' ? 'b' : 'a'); cycle(); }, DUR);
    }
    function take(s) { auto = false; clearTimeout(timer); root.classList.remove('is-auto'); setState(s); }
    btns.forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); take(b.dataset.s); }); });
    root.addEventListener('click', function () { take(root.dataset.state === 'a' ? 'b' : 'a'); });
    for (var w = 0; w < 120; w++) step(1 / 30);   // open with a full trace on screen
    draw();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          seen = e.isIntersecting;
          vids.forEach(function (v) { if (seen && !reduce) v.play().catch(function () {}); else v.pause(); });
          if (seen && !reduce && !running) { running = true; last = 0; requestAnimationFrame(frame); } else if (!seen) running = false;
          cycle();
        });
      }, { threshold: .45 }).observe(root);
    }
  }

  /* Sock buying options (Buy 1 pair / Buy 2 get 2 free): the picked card sets the product form's quantity (1 or 4), so
     Add to cart, the sticky bar and Shop Pay all add what the card says, and the buttons name it. The theme rewrites the
     button text when the variant changes, so the label goes back on after that; a sold-out button keeps the theme's text. */
  function initDeal(root) {
    if (!once(root, 'd26pdpDeal')) return;
    var sid = root.dataset.section, radios = $$('input[type="radio"]', root);
    var forms = ['#productForm-' + sid, '#productStickyForm-' + sid];
    function pick() { return radios.filter(function (r) { return r.checked; })[0] || radios[radios.length - 1]; }
    function label() {
      var l = pick().dataset.label;
      forms.forEach(function (f) {
        $$(f + ' .js-product-form-submit-btn', document).forEach(function (b) {
          var t = $('.js-product-form-submit-btn-text', b);
          if (t && !b.disabled && !$('.product-btn-atc__suffix', b) && t.textContent !== l) t.textContent = l;
        });
      });
    }
    function apply() {
      var q = pick().value;
      forms.forEach(function (f) {
        $$('input[name="quantity"][form="' + f.slice(1) + '"]', document).forEach(function (i) {
          if (i.value === q) return;
          i.value = q;
          i.dispatchEvent(new Event('input', { bubbles: true })); i.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      label();
    }
    radios.forEach(function (r) { r.addEventListener('change', apply); });
    /* The theme builds the sticky bar and rewrites the buttons after this runs, so the pick is re-applied whenever the
       buy box changes and once the page has loaded. apply() only touches what differs, so it settles at once. */
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 30); })
      .observe(root.closest('.js-main-product') || document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    window.addEventListener('load', apply);
    apply();
  }

  /* Phone: the theme's sticky Add to cart bar (~160px) would cover the cards in the one-screen sections, so it steps
     aside while the feature map, photo stack or key-feature switch fills the screen, and comes back everywhere else. */
  var onScreen = new Set();
  var stickyIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target); });
    document.documentElement.classList.toggle('d26pdp-hide-sticky', onScreen.size > 0 && !desk.matches);
  }, { threshold: .5 }) : null;

  function init(root) {
    root = root || document;
    $$('[data-d26pdp-fmap]', root).forEach(initFeatureMap);
    $$('[data-d26pdp-stack]', root).forEach(initStack);
    if (stickyIO) $$('[data-d26pdp-fmap], [data-d26pdp-stack], [data-d26pdp-switch]', root).forEach(function (el) { stickyIO.observe(el); });
    $$('[data-d26pdp-ba]', root).forEach(function (el) { if (once(el, 'd26pdpBa')) dragLine(el); });
    $$('[data-d26pdp-switch]', root).forEach(initSwitch);
    $$('video[data-d26pdp-loop]', root).forEach(initLoop);
    $$('[data-d26pdp-weave]', root).forEach(initWeave);
    $$('script[data-d26pdp-gallery-notes]', root).forEach(initGalleryNotes);
    $$('[data-d26pdp-tabs]', root).forEach(initTabs);
    $$('[data-d26pdp-spec]', root).forEach(initSpec);
    $$('[data-d26pdp-deal]', root).forEach(initDeal);
  }
  window.D26PDP = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
